<template>
  <div>
    <v-dialog persistent :value="editModal" width="500">
      <v-card>
        <v-card-title>{{'Edit brand ' + form.name}}</v-card-title>
        <v-card-text>
          <div>
            <v-form ref="updateForm" lazy-validation>
              <v-text-field
                v-model="form.name"
                :rules="textValidation"
                name="Name"
                label="Name"
                required
                validate-on-blur
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="form.description"
                :rules="textValidation"
                name="Description"
                label="Description"
                required
                validate-on-blur
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="form.order"
                :rules="positiveNumberValidation"
                name="Order"
                label="Order"
                required
                validate-on-blur
                type="number"
              ></v-text-field>
              <v-flex sm12 md12 class="text-left">
                <img class="display-img" :src="form.logo" alt v-if="form.logo" />
              </v-flex>
              <div class="text-left mb-3">
                <v-btn class="ml-0" color="primary" @click.prevent="openAttachmentPopup()">
                  <v-icon dark left>fas fa-image</v-icon>
                  {{ form.logo == '' ? 'select image' : 'update image'}}
                </v-btn>
              </div>
            </v-form>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            @click="closeModal()"
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
            style="text-transform: capitalize;"
          >Cancel</v-btn>
          <v-btn
            @click="updateData()"
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-0 primary' : 'ml-0 primary'"
            style="text-transform: capitalize;"
          >Edit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import { BrandAPI } from '@/clients/product/brand.api.js'
export default {
  data() {
    return {
      normalValidation: [
        v => !!v || 'Field is required'
      ],
      textValidation: [
        v => !!v || 'Field is required'
      ],
      positiveNumberValidation: [
        v => !!v || 'Field is required',
        v => /^\+?(0|[1-9]\d*)$/.test(v) || 'Positive numbers only'
      ],
      form: {
        name: '',
        logo: '',
        description: '',
        order: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      editModal: 'brand/editPop',
      editObj: 'brand/editObj'
    })
  },
  watch: {
    'editObj': function (val) {
      if (!_.isEmpty(val)) {
        //   this.$refs.updateForm.resetValidation()
        for (let key in this.form) {
          this.form[key] = val[key]
        }
      }
    }
  },
  mounted() {
    if (this.editModal) {
      this.closeModal()
    }
    /**
     * Set image
     */
    this.$root.$on('resource-selected', (event) => {
      if (this.editModal) {
        this.form.logo = event[0].full_url
      }
    })
  },

  methods: {
    /**
     * Update
     */
    async updateData() {
      if (this.$refs['updateForm'].validate()) {
        try {
          // Trigger apis
          this.spinner(true)
          let result = await BrandAPI.edit(this.editObj.id, this.form)
          this.spinner(false)
          if (result.status === 200) {
            this.closeModal()
          }

          this.$refs['updateForm'].reset()
          this.$root.resourcePicker.resource = null

          // // Display message alert
          this.snackbar({
            text: result.status === 200 ? result.data.msg : result.response.data.errors ? result.response.data.errors[0] : result.response.data.msg,
            open: true,
            color: result.status === 200 ? 'success' : 'error'
          })
        } catch (err) {
          console.log('@views/edit:M_updateData')
          this.spinner(false)
          this.snackbar({
            text: err.response.data.errors ? err.response.data.errors[0] : err.response.data.message,
            open: true,
            color: 'error'
          })
        }
      }
    },

    /**
     * Popup for attachment
     */
    openAttachmentPopup() {
      this.openResourcePicker()
    },

    /**
     * Close modal
     */
    closeModal() {
      this.setEditPop(false)
      this.setEditObj({})
    },

    ...mapActions({
      va_brandList: 'brand/setList',
      setEditPop: 'brand/setEditPop',
      setEditObj: 'brand/setEditObj'
    })
  }
}
</script>
